import config from "../../config";
import { CartItem } from "../../Interfaces/Types";
import { ShippingInfo } from "../../Interfaces/ShippingInfo";
import apiClient from "../../services/apiClient";
import { LoggedInAccount } from "../../Interfaces/AccountUsers";

const DONATION_ID = config.DONATION_ITEM_ID;
const BUYOUT_ID = config.BUYOUT_ITEM_ID;
const BASE_API = config.API_BASE_URL;

const createPaymentIntent = async (
  shippingInfo: ShippingInfo | null = null,
  shippingOption: string,
  customerName: string,
  customerEmail: string,
  customerPhoneNumber: string,
  cart: CartItem[],
  fundraiser_participant_id: number,
  user: LoggedInAccount | null = null,
  squareOrderID: string,
  shippingCost: string,
) => {
  try {
    const response = await apiClient.post(
      `${BASE_API}checkout/create-payment-intent/square/`,
      {
        cartContents: {
          shippingInfo: shippingInfo,
          shippingOption: shippingOption,
          squareOrderID: squareOrderID,
          customerName: customerName,
          customerEmail: customerEmail,
          customerPhoneNumber: customerPhoneNumber,
          cart: cart,
          fundraiser_participant: fundraiser_participant_id,
          user: user,
          donation_sku: DONATION_ID,
          buyout_sku: BUYOUT_ID,
          shippingCost: shippingCost,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Error during checkout:", error);
  }
};

export default createPaymentIntent;
